// extracted by mini-css-extract-plugin
export default {"inputs":"styles_inputs__HbxRN","actions":"styles_actions__ly8xF"};